import { render, staticRenderFns } from "./OrderMsg.vue?vue&type=template&id=00daa19a&scoped=true&"
import script from "./OrderMsg.vue?vue&type=script&lang=js&"
export * from "./OrderMsg.vue?vue&type=script&lang=js&"
import style0 from "./OrderMsg.vue?vue&type=style&index=0&id=00daa19a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00daa19a",
  null
  
)

export default component.exports